/**
 * Browser-bunyan stream that writes logs to Datadog RUM
 */
import { datadogRum } from '@datadog/browser-rum';

import { isDatadogEnabled } from '../lib/DatadogClient';

interface LogRecord {
  level: number;
  levelName: string;
  msg: string;
  component?: string;
  err?: Error;
  [key: string]: unknown;
}

export class DatadogStream {
  write(rec: LogRecord): void {
    if (!isDatadogEnabled()) {
      return;
    }

    const { msg, level, levelName, component, err, ...context } = rec;

    const logMessage = component ? `${component}: ${msg}` : msg;
    const logContext = {
      ...context,
      component,
      level: levelName,
    };

    try {
      if (level >= 40) {
        // warn, error, fatal
        let errorType = 'warning';
        if (level === 60) {
          errorType = 'fatal';
        } else if (level === 50) {
          errorType = 'error';
        }

        const errorToLog = err || new Error(logMessage);
        datadogRum.addError(errorToLog, {
          ...logContext,
          errorType,
        });
      } else if (level >= 30) {
        // info
        datadogRum.addAction(logMessage, logContext);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('DatadogStream error:', error);
      }
    }
  }
}
